import script from "./vmsAffiliationManager.vue?vue&type=script&lang=js"
export * from "./vmsAffiliationManager.vue?vue&type=script&lang=js"

import "./vmsAffiliationManager.vue?vue&type=style&index=0&id=0302af16&scoped=true&lang=css"
import "./vmsAffiliationManager.vue?vue&type=style&index=1&id=0302af16&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0302af16"]])

export default __exports__